module.exports = __webpack_public_path__ + "static/member-profile-lm-patnaik-e6b135f3b91d98135ca49caff06bf6e5.jpg";